<p v-if="isLoading" class="basis-full text-center text-gray-500">Loading...</p>


<div v-else class="list-view mt-2 lg:mt-3">
    <div class="overflow-x-auto lg:flex lg:justify-center mb-1 lg:mb-2">
        <ul role="tablist"
            class="whitespace-nowrap w-full lg:whitespace-wrap lg:flex lg:flex-row lg:flex-wrap lg:w-fit border-b border-gray-200"
        >
            <li role="tab" class=" inline-block" v-for="filter in regionFilters" :key="filter.htmlID">
                <a href="#"
                   :class="{ 'active bg-primary-lightest font-bold text-primary hover:text-primary': selectedRegion === filter.region }"
                   class="inline-block py-0.75 px-1 lg:px-1.5 xl:py-1 lg:text-lg cursor-pointer text-gray-600"
                   @click.prevent="$emit('update:selectedRegion', filter.region)"
                >
                    {{ filter.title }}
                </a>
            </li>
        </ul>
    </div>

    <div class="my-1" v-for="filter in regionFilters" :key="'tab-content-' + filter.region">
        <div
                v-if="selectedRegion === filter.region"
                role="tabpanel"
        >
            <ul v-if="results.length" class="grid lg:grid-cols-2 mb-2 gap-x-6">
                <li class="relative flex flex-wrap items-center hover:bg-primary-lightest justify-between gap-x-2 p-0.5 xl:py-1 border-b" v-for="result in results" :key="result.objectID">
                    <p class="mb-0 text-primary font-bold lg:text-ellipsis lg:max-w-[300px] lg:truncate">{{ result.objectTitle }}</p>
                    <span>
                        <template v-if="result.objectType === 'Page'">
                            <span class=" text-primary text-xs ">
                                <span>{{ result.objectPublishDate }}</span>
                                <span class="mx-qtr" aria-hidden="true" v-if="result.objectPublishDate">&bull;</span>
                            </span>
                        </template>
                        <span class="text-primary text-xs font-bold uppercase whitespace-nowrap overflow-hidden text-ellipsis tracking-wider">
                            <template v-if="result.objectCategory && result.objectType === 'Listing'">
                                {{ result.objectCategory }}
                            </template>
                            <template v-else-if="result.objectCategories && result.objectType === 'Page'">
                                {{ getCategoryName(result.objectCategories[0]) }}
                            </template>
                        </span>
                    </span>
                    <a class="absolute-cover" :href="result.objectLink"><span class="sr-only">{{ result.objectTitle }}</span></a>
                </li>
            </ul>
            <p v-else class="basis-full text-center text-gray-600">No results found. Try again.</p>
        </div>
    </div>
</div>


